import {Component, input, OnInit, output} from '@angular/core';
import {Headline} from '../../../../../shared/models/configuration.model';
import {FormsModule} from '@angular/forms';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatTooltip} from '@angular/material/tooltip';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {MatInput} from '@angular/material/input';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';

@Component({
  selector: 'app-headline',
  templateUrl: './headline.component.html',
  styleUrls: ['./headline.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    FormsModule,
    MatTooltip,
    MatIcon,
    MatIconButton,
    MatSlideToggle,
    MatInput,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger
  ]
})
export class HeadlineComponent implements OnInit {

  headline = input<Headline>();

  editedHeadline: Headline;

  headlineDeleted = output<void>();
  headlineSelected = output<boolean>();
  headlineUpdated = output<Headline>();

  beingEdited: boolean;

  constructor() { }

  ngOnInit(): void {
    this.beingEdited = false;
  }

  edit() {
    this.beingEdited = true;
    this.editedHeadline = {...this.headline()};
  }

  update() {
    this.beingEdited = false;
    this.headlineUpdated.emit(this.editedHeadline);
  }

  cancel() {
    this.beingEdited = false;
  }

  selectedChanged() {
    this.headlineSelected.emit(!this.headline().selected);
  }
}
